import DOMPurify from "dompurify";

/**
 * Rich text support for Forms Library long-form instructional content
 * (template description, intro_text, and a text_block field's
 * help_text) — Aug 2026 fix for newlines/blank-lines collapsing into one
 * paragraph. Mirrors the existing WIM Blog/Care News Quill+DOMPurify
 * pattern (see AdminArticleEditor.jsx / ArticleBody.jsx) but with a
 * deliberately smaller allowed tag set: no blockquote/link/images —
 * just paragraphs, line breaks, two heading sizes, bold, italic and
 * lists, so forms stay visually plain and on-brand.
 */
export const FORMS_ALLOWED_TAGS = ["p", "br", "strong", "em", "ul", "ol", "li", "h3", "h4"];

const HTML_TAG_RE = /<[a-z][\s\S]*>/i;

export function isHtmlContent(text) {
  return typeof text === "string" && HTML_TAG_RE.test(text);
}

function escapeHtml(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

// Legacy plain-text content has no HTML tags at all — convert to simple
// paragraphs so it displays correctly inside the Quill editor. Existing
// HTML is passed through DOMPurify first (defence in depth — the render
// path already sanitises on every display surface, this additionally
// makes sure the editor itself never has to hold onto anything
// dangerous while it's open for editing). Purely a display convenience;
// the database is untouched unless the admin actually clicks Save.
export function toEditableHtml(text) {
  if (!text) return "";
  if (isHtmlContent(text)) return sanitizeFormsHtml(text);
  return text.split(/\n\s*\n/).map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`).join("");
}

export function sanitizeFormsHtml(html) {
  return DOMPurify.sanitize(html || "", { ALLOWED_TAGS: FORMS_ALLOWED_TAGS, ALLOWED_ATTR: [] });
}
